import React from 'react';
import ReactDOM from 'react-dom/client';
// 🎯 Swapped BrowserRouter out for HashRouter to prevent 404/blank page errors on refresh
import { HashRouter as Router } from 'react-router-dom';
import App from './App';
import './index.scss';
import ScrollToTop from "../src/components/scrollToTop";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <ScrollToTop />
      <App />
    </Router>
  </React.StrictMode>
);
